import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchPlaceholder: {
		id: 'project-create-importer-upload-flow.select-source-screen.source-section.search-placeholder',
		defaultMessage: 'Search apps',
		description: 'The text for default search input',
	},
	switchBackToOldExperience: {
		id: 'project-create-importer-upload-flow.select-source-screen.source-section.switch-back-to-old-experience',
		defaultMessage:
			'This experience is only available for Jira business and software project imports. If you’d like to import your data into Jira Service Management or Jira Product Discovery, <link>switch to the old experience</link>. ',
		description: 'The text for default search input',
	},
	errorHeading: {
		id: 'project-create-importer-upload-flow.select-source-screen.source-section.error-heading',
		defaultMessage: 'We’re having trouble loading this page',
		description: 'Heading for source screen error',
	},
	errorDescription: {
		id: 'project-create-importer-upload-flow.select-source-screen.source-section.error-description',
		defaultMessage: 'Try refreshing the page or check back again in a few minutes.',
		description: 'Description for source screen error',
	},
});
